import React from 'react';

import moment from 'moment';

import {OrderHistoryRecord} from "../../../../types/Order";

type Props = {
  tz?:string;
  record:OrderHistoryRecord;
}
const OrderHistoryRow = (props:Props) => {
  const {updatedAt, status, updatedBy} = props.record;

  const dateColumn = props.tz
    ? moment(updatedAt).tz(props.tz).format('MMM DD YYYY hh:mm A z')
    : moment(updatedAt).format('MMM DD YYYY hh:mm A z');

  const updatedByString = updatedBy
    ? `${updatedBy.name} (${updatedBy.email})`
    : 'Unknown';

  return (
    <>
      <tr>
        <td>{dateColumn}</td>
        <td>{status}</td>
        <td>{updatedByString}</td>
      </tr>
    </>
  );
};

export default OrderHistoryRow;
